var t=Function.prototype.toString;var r=function(r){if(null!=r){try{return t.call(r)}catch(t){}try{return r+""}catch(t){}}return""};export{r as default};
//# sourceMappingURL=_toSource.js.map
